module.exports = __webpack_public_path__ + "static/media/Jar.e3e7beb0.jpg";